<template>
	<v-app>
		<v-main :class="homePath ? 'home-path' : 'internal-path'">
			<router-view />
		</v-main>

		<ConfirmDialog ref="confirmDialog"></ConfirmDialog>
		<LogoutMessageDialog ref="logoutMessageDialog"></LogoutMessageDialog>
		<AppToaster></AppToaster>
	</v-app>
</template>

<script>
import clientApi from '@/common/api/client.api';
import userApi from '@/common/api/user.api';
import AppToaster from '@/components/layout/AppToaster';
import ConfirmDialog from '@/components/layout/ConfirmDialog';
import LogoutMessageDialog from '@/components/layout/LogoutMessageDialog';
import { setLanguage } from '@/plugins/i18n';

export default {
	name: 'App',

	components: {
		ConfirmDialog,
		LogoutMessageDialog,
		AppToaster,
	},

	computed: {

		homePath() {
			return (
				this.$route &&
				this.$route.matched &&
				this.$route.matched.length >= 2 &&
				this.$route.matched[0].name === 'Home'
			);
		},
	},

	mounted() {
		this.$root.$confirmDialog = this.$refs.confirmDialog.open;
		this.$root.$logoutMessageDialog = this.$refs.logoutMessageDialog.open;

		this.loadTheme();
		this.setUserLanguage();
	},

	methods: {
		setUserLanguage() {
			const language = userApi.getUserLocale();
			return setLanguage(language);
		},
		loadTheme() {
			clientApi.applyTheme();
		},
	},
};
</script>

<style lang="scss" scoped>
.v-main {
	background-color: #f6f8fa;
}
</style>
